import { render, staticRenderFns } from "./EmployeeLeaveHistory.vue?vue&type=template&id=4dd33d54&scoped=true&"
import script from "./EmployeeLeaveHistory.vue?vue&type=script&setup=true&lang=js&"
export * from "./EmployeeLeaveHistory.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd33d54",
  null
  
)

export default component.exports